var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_3562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85489 3.37622L0.208198 6.24121L0.190177 12.0028L0.178162 17.7696L5.86091 20.6452C8.9846 22.2251 11.5617 23.5206 11.5917 23.5206C11.6217 23.5206 13.1776 22.7412 15.0578 21.7933C16.932 20.84 19.491 19.5497 20.7405 18.9177L23.0052 17.7696V16.5372V15.2996L22.8731 15.3628C22.795 15.3997 20.236 16.69 17.1843 18.2384C14.1267 19.7867 11.5977 21.0401 11.5617 21.0349C11.5196 21.0243 9.50121 20.0131 7.06833 18.7808L2.64108 16.5424V12.0133V7.48411L4.64146 6.47293C5.73474 5.91996 7.74113 4.90878 9.09274 4.22414C10.4383 3.53948 11.5677 2.98124 11.5917 2.98124C11.6157 2.98124 13.1836 3.76594 15.0758 4.72445L20.5905 7.48411L21.4602 7.03543L23.0052 6.24121L20.5905 5.03518C18.68 4.04506 11.6337 0.50597 11.5737 0.511236C11.5376 0.511236 8.96058 1.80153 5.85489 3.37622Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3586 9.10075C14.2709 10.6649 11.6999 11.9605 11.6458 11.971C11.5857 11.9868 10.0779 11.2495 8.1136 10.2594L4.68353 8.52143V9.76961L4.68953 11.0125L8.02349 12.6978C9.85566 13.6247 11.4175 14.4041 11.4956 14.4305C11.6157 14.4673 12.4567 14.0618 17.2745 11.6234C20.3741 10.0487 22.9331 8.74789 22.9631 8.72683C22.9872 8.70577 22.9993 8.14225 22.9933 7.47339L22.9752 6.25684L17.3586 9.10075Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3746 11.0862C22.0441 11.2495 19.4972 12.5398 16.7098 13.9512C13.9225 15.3626 11.6218 16.516 11.5917 16.516C11.5617 16.516 10.0059 15.7366 8.12565 14.7886L4.7136 13.0612L4.69558 14.2725C4.68356 15.1994 4.70158 15.4996 4.75565 15.547C4.86977 15.6365 11.5197 18.9912 11.5917 18.9912C11.6518 18.9912 22.8672 13.3298 22.9632 13.256C22.9872 13.235 22.9993 12.6715 22.9933 11.9973L22.9753 10.7808L22.3746 11.0862Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_3562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.139,
    height: 23.139,
    fill: "white",
    transform: "translate(0 0.51123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.48328531d1cd3143b2c566026d1865da.svg";
export { ForwardRef as ReactComponent };